import React from "react";
import T from "./../TheTool";

function GUI_InputTextArea(props) {
	

	var fontSize1 = T.getValue(props.fontSize1, 28);

	const handleTextChange = (event) => {
		props.area1Change(event.target.value);
	};

	function Head() {
		var label1 = T.getValue(props.label, "");
		var label2 = T.getValue(props.label2, "");
		return (
			<div>
				<label style={{ fontSize: fontSize1 }}>
					<b>{label1}</b>
				</label>
				<label style={{ alignItems: "right", paddingLeft: 20, fontSize: 16 }}>
					{label2}
				</label>
			</div>
		);
	}

	function Area1() {
		var text1 = T.getValue(props.text1, "");
		var txt_placeholder = T.getValue(props.txt_placeholder, "");
		return (
			<textarea
				id="inputItemList"
				className="textarea_001"
				placeholder={ txt_placeholder }
				// placeholder={"name,weight,value\nname,weight,value\nname,weight,value"}
				// style={{ minHeight: "308px", whiteSpace: "pre-line" , fontSize: 28  }}
				style={{ minHeight: "308px", whiteSpace: "pre-line" }}
				// defaultValue={txtDefault}
				// defaultValue="A,12,4B,4,10 C,2,2 D,1,2 E,1,1"
				value={text1}
				onChange={handleTextChange}
			></textarea>
		);
	}

	return (
		<div>
			{Head()}
			<div style={{ marginTop: "0.5em" }}> </div>
			{Area1()}
		</div>
	);
}

export default GUI_InputTextArea;
